'use client';

import { Link } from '@lib/navigation';
import Image from 'next/image';

import { getArticleImgUrl } from '@utils/getters';
import { RelatedArticleI } from 'types/article';
import { useTranslations } from 'next-intl';

interface ArticleSuggestionsProps {
  relatedArticles: RelatedArticleI[];
}

const ArticleBox = ({ article, index }: { article: RelatedArticleI, index: number }) => {
  return (
    <Link href={`/${article.slug}`} className="group" id={`transinfo_post_suggested_click_${index}`}>
      <div key={`${index}-${article.slug}`} className="w-full overflow-hidden">
        <div className="w-full rounded-xl overflow-hidden">
          <Image
            src={getArticleImgUrl(article, 'large') || ''}
            loading="lazy"
            width={960}
            height={540}
            alt={article.title}
            className="w-full max-h-[260px] object-cover aspect-video overflow-hidden transition-transform duration-1000 group-hover:scale-105 rounded-xl lg:max-h-none"
          />
        </div>
        <div className="text-md my-2">
          {article.title}
        </div>
      </div>
    </Link>
  );
};

export default function ArticleSuggestions({ relatedArticles }: ArticleSuggestionsProps) {
  const t = useTranslations('main.posts');
  return (
    <>
      <h2 className="text-blue text-[1.5rem] leading-[2rem] font-extrabold mx-4 mb-8 md:text-[1.875rem] md:leading-[2.25rem]">
        {t('alsoRead')}
      </h2>
      <div className="grid grid-cols-1 gap-4 m-4 lg:grid-cols-2 xl:grid-cols-3">
        {relatedArticles.map((article, index) => ((index < 6) &&
          <ArticleBox key={article.slug} article={article} index={index} />
        ))}
      </div>
    </>
  );
}
